<template>
  <Slide class="NumDevicesSlide"
    v-bind="{ isCurrentSlide, isStartingSlide, mayContinue }"
    :title="content.title"
    nextAction="nextSlide"
  >
    <SingleOptionSelect
      name="numDevices"
      :options="content.options"
      :value="fieldValues.numDevices"
      :disabled="!isCurrentSlide"
      @selectionChange="doUpdateField"
    />
  </Slide>
</template>

<script>
import { slideProps } from '../util/slideBuilders.js'

import SingleOptionSelect from './elems/SingleOptionSelect.vue'
import Slide from './elems/Slide.vue'

export default {
  inject: ['updateField', 'updateOption', 'nextSlide'],
  components: {
    Slide,
    SingleOptionSelect,
  },
  props: slideProps,
  computed: {
    mayContinue() {
      return Boolean(this.fieldValues.numDevices)
    },
  },
  methods: {
    doUpdateField(value) {
      this.updateField?.('numDevices', value, 'sync')
      this.updateOption?.('oneDeviceOnly', value === '1')
      this.nextSlide?.()
    },
  },
}
</script>
